import React, { useEffect } from "react";
import { TOptions, TOptionValue } from "../optionsUtils";
import Checkbox from "../types/checkbox/Checkbox";
import Radio from "../types/radio/Radio";
import Toggle from "../types/toggle/Toggle";

import "./OptionContainer.scss";

interface IProps {
    id: string;
    type: TOptions;
    title?: React.ReactNode | undefined;
    description?: React.ReactNode | undefined;
    value?: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function OptionContainer(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue>(props.value || "unselected");

    const onClick = (e) => {
        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (props.type === "radio") {
            // For radios, keep the selection; clicking again should not deselect.
            if (value !== "selected") {
                setValue("selected");
            }
            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <button
            id={props.id + "-option-container"}
            type="button"
            onClick={onClick}
            className={`userful-opiton-container noselect ${
                value === "selected"
                    ? "userful-opiton-container-selected"
                    : value === "indeterminate"
                      ? "userful-opiton-container-indeterminate"
                      : ""
            } 
            ${props.disabled ? "userful-opiton-container-disabled" : ""}`}
        >
            <div className="userful-opiton-input">
                {props.type === "checkbox" && <Checkbox value={value} onClick={onClick} disabled={props.disabled} />}
                {props.type === "radio" && <Radio value={value} onClick={onClick} disabled={props.disabled} />}
                {props.type === "toggle" && <Toggle value={value} onClick={onClick} disabled={props.disabled} />}
            </div>
            <div className="userful-opiton-text">
                <h1>{props.title}</h1>
                <p>{props.description}</p>
            </div>
        </button>
    );
}
